import React from "react";
import { useAppVersion } from "../../../utils/useAppVersion";

export default function AppUpdateBanner() {
    const updateAvailable = useAppVersion();
    if (!updateAvailable) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                background: "#1a56db",
                color: "#fff",
                padding: "10px 24px",
                zIndex: 99999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
                fontSize: "14px",
                fontFamily: "Poppins, sans-serif"
            }}
        >
            <span>
                <strong>Update available</strong> — A new version of this application has been deployed.
            </span>
            <button
                onClick={() => window.location.reload()}
                style={{
                    background: "#fff",
                    color: "#1a56db",
                    border: "none",
                    borderRadius: "4px",
                    padding: "5px 16px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "13px",
                    flexShrink: 0,
                    whiteSpace: "nowrap"
                }}
            >
                Reload now
            </button>
        </div>
    );
}
